import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { Dispatch, SetStateAction } from "react";
import { IAtualizacao, IFeedback } from "../../../../Interfaces/Sprint/Sprint";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { InserirVisualizacaoSprintController } from "../../../../Controllers/Sprint/SprintController";

interface IUltimasAtualizacaoProps {
    lstAtualizacao: IAtualizacao;
    setShow: Dispatch<SetStateAction<boolean>>;
    lstAtualizacaoLoading: boolean;
    idUsuario: number;
}

export default function UltimasAtualizacao(props: IUltimasAtualizacaoProps) {
    const FormMethods = useForm();
    let arrayAvaliacao = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    function handleFeedbackSubmit(formData: IFeedback) {
        InserirVisualizacaoSprintController({
            DS_OBSERVACAO: formData.FL_AVALIADO ? "" : formData.DS_OBSERVACAO,
            NR_RELEVANCIA: Number(formData.NR_RELEVANCIA),
            ID_USUARIO: props.idUsuario,
            FL_AVALIADO: formData.FL_AVALIADO ? false : true,
            ID_SPRINT: props.lstAtualizacao.ID_SPRINT,
        }).then(() => props.setShow(false));
    }
    return (
        <FormProvider {...FormMethods}>
            <UnForm usingContext handleSubmit={handleFeedbackSubmit}>
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <h1 className="font-weight-bolder text-dark gruposTitle">
                        {props.lstAtualizacao.DS_NOME}
                    </h1>
                    <label>
                        <span className="card-label font-weight-bolder text-dark gruposTitle">
                            De 0 à 10 quão relevante foi as últimas atualizações
                        </span>
                    </label>
                    <div className="row" style={{ gap: "12px" }}>
                        {arrayAvaliacao.map((i) => {
                            return (
                                <div className="align-items-center d-flex">
                                    <UnForm.Input
                                        type="radio"
                                        name="NR_RELEVANCIA"
                                        label={String(i)}
                                        value={i}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                {props.lstAtualizacao.ITEM_SPRINT.map((item) => {
                    return (
                        <div>
                            <h3 className="font-weight-bolder text-dark ">
                                {item.DS_TIPO}:
                            </h3>
                            <p className="font-weight-bolder text-dark ">
                                {item.DS_DESCRICAO}
                            </p>
                        </div>
                    );
                })}
                <UnForm.Textarea
                    label="Diga o que você achou?"
                    name="DS_OBSERVACAO"
                />

                <UnForm.SubmitButton
                    loading={props.lstAtualizacaoLoading}
                    wrapperClassName="d-flex col-12 justify-content-end mt-6 mr-0 p-0"
                    disabled={props.lstAtualizacaoLoading}
                    className="col-12"
                    icon={faCheck}
                    color="success"
                    loadingSize="sm"
                >
                    Enviar
                </UnForm.SubmitButton>

                <div className="d-flex align-items-center">
                    <UnForm.Input
                        wrapperClassName="d-flex mr-2"
                        type="checkbox"
                        style={{ scale: "1.2" }}
                        name="FL_AVALIADO"
                    />
                    <span>Não Avaliar</span>
                </div>
            </UnForm>
        </FormProvider>
    );
}
